export default __webpack_public_path__ + "static/media/27.545f92fa.jpg";